import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/Check';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import axios from './../../config/axiosInstance';
import BasicPlanImage from '../../assets/images/plan_basic.svg';
import PremiumPlanImage from './../../assets/images/plan_premium.svg';
import SubscriptionHistory from '../../containers/Subscription/SubscriptionHistory'
import Chip from '@material-ui/core/Chip';
import "./styles.css";

const useStyles = makeStyles((theme) => ({
    root: {
        justifyContent: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            width: '339px',
            margin: '20px',
        },
    },
    descriptionItem: {
        marginLeft: '40px',
    },
    descriptionItemSvg: {
        color: '#40c78d',
        marginTop: 'auto',
        marginBottom: 'auto',
        marginRight: '5px',
        fontSize: '20px',
    },
    switchValuePlans: {
        width: '56px',
        height: '33px',
        marginTop: '-24px',
        position: 'absolute',
    },
}));

export default function PlansSubscription({
    handleNext,
    checked,
    setChecked,
    setPlanSelected,
    urlplan,
}) {
    const classes = useStyles();
    const [plans, setPlans] = React.useState({});


    useEffect(() => {
        async function fetchGraphs() {
            const result = await axios.post('/payments/paypal/show-offers');
            setPlans(result.data);
            urlplan(result.data);
        }
        fetchGraphs();
    }, []);

    const handleChangeValue = () => {
        if (checked) {
            setChecked(false);
        } else {
            setChecked(true);
        }
    };


    const formatValue = plans => plans !== null && plans.toFixed(2).replace('.', ',');

    return (
        <div className={classes.root}>
            <div className={classes.switchValuePlans}>
                <Typography style={{ display: 'flex', justifyContent: 'center', }}>
                    Mensal
                    <div style={{ marginTop: '-7px' }}>
                        <Switch
                            checked={checked}
                            onChange={handleChangeValue}
                            color="primary"
                            name="checked"
                        />
                    </div>
                    Anual
                </Typography>
            </div>
            {
                (plans && plans.offers) && plans.offers.map(i => (
                    <Paper elevation={3} >
                        <Typography style={{ textAlign: 'center', padding: '10px' }}>{i.description}</Typography>
                        {
                            i.isActive ? (
                                <div style={{ textAlign: 'center', paddingRight: '8px', }}>
                                    <Chip
                                        size="small"
                                        label={i.isTrial ? 'Avaliação' : 'Ativo'}
                                        id="currentChip"
                                        style={{ color: 'white', backgroundColor: i.isTrial ? '#FF6464' : '#00D279' }}
                                    />
                                </div>
                            ) : <div style={{ textAlign: 'center', paddingRight: '8px', }}><div id="currentChip"></div></div>
                        }
                        <div style={{ textAlign: 'center' }}>
                            {i.id === 11 && <img src={BasicPlanImage} alt="Imagem Plano Básico" />}
                            {i.id === 13 && <img src={PremiumPlanImage} alt="Imagem Plano Premium" />}
                            {i.id === 17 && <img src={PremiumPlanImage} alt="Imagem Plano Premium" />}
                            {i.id === 18 && <img src={PremiumPlanImage} alt="Imagem Plano Premium" />}
                        </div>

                        {
                            checked ?
                                <Typography variant="h2" style={{ fontSize: '2.25rem', textAlign: 'center' }}>
                                    R$ {formatValue(i.yearlyPriceInstallments)}
                                    <Typography inline variant="h5" component="span">
                                        /mês
                                    </Typography>
                                </Typography>
                                :
                                <Typography variant="h2" style={{ fontSize: '2.25rem', textAlign: 'center' }}>
                                    R$ {formatValue(i.monthlyPrice)}
                                    <Typography inline variant="h5" component="span">
                                        /mês
                                    </Typography>
                                </Typography>
                        }

                        <div style={{ marginBottom: '1.25em' }}>
                            {i.id == 11 ?
                                <Typography variant='body2' gutterBottom className={classes.descriptionItem}>
                                    <CheckIcon className={classes.descriptionItemSvg} />
                                    <a href="https://www.puntu.digital/#how-works" rel="noopener noreferrer" target="_blank">Funcionalidades básicas</a>
                                </Typography>
                                :
                                i.benefits.split('\\n') && i.benefits.split('\\n').map(content => (
                                    <Typography variant='body2' key={content} gutterBottom className={classes.descriptionItem}>
                                        <CheckIcon className={classes.descriptionItemSvg} />
                                        {
                                            content === 'Funcionalidades básicas' ?
                                                <a href="https://www.puntu.digital/#how-works" rel="noopener noreferrer" target="_blank">{content}</a> :
                                                content
                                        }
                                    </Typography>
                                ))
                            }
                        </div>
                        <div>
                            {i.id == 11 ? '' : <Button
                                variant="contained"
                                // fullWidth
                                style={{ width: '90%', margin: '17px', marginTop: i.id == 17 ? '41px' : '' }}
                                color="primary"
                                onClick={() => {
                                    handleNext();
                                    setPlanSelected(i);
                                }}
                            // disabled={monthlyPrice === 0}
                            // style={{
                            //     opacity: monthlyPrice === 0 ? 0 : 1,
                            //     cursor: monthlyPrice === 0 ? 'unset' : 'pointer',
                            // }}
                            >
                                COMPRAR
                            </Button>}
                        </div>
                    </Paper >
                ))
            }
            <div style={{ width: '100%' }}>
                <SubscriptionHistory payments={plans.payments || []} />
            </div>
        </div >
    );
} 